import React, { useEffect, useState } from 'react';
import { breakpoints } from '@naf/theme';
import { colors, simbaStyled } from '@naf-simba/theme';
import { ArrowUpward } from '@styled-icons/material/ArrowUpward';
import { animated, config, useSpring } from '@react-spring/web';

type Props = {
  show: boolean;
  onClick: () => void;
};

export const BackToTopButton: React.FC<Props> = ({ show, onClick }) => {
  const [lastScrollY, setLastScrollY] = useState(0);
  const [userIsScrollingUp, setUserIsScrollingUp] = useState<boolean>(false);

  const [props] = useSpring(
    () => ({
      config: config.gentle,
      from: { opacity: 0, y: 20 },
      to: {
        opacity: userIsScrollingUp ? 1 : 0,
        y: userIsScrollingUp ? 0 : 20,
      },
    }),
    [userIsScrollingUp],
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const listen = () => {
        if (window.scrollY > lastScrollY) {
          setUserIsScrollingUp(false);
        } else if (window.scrollY < 250) {
          setUserIsScrollingUp(false);
        } else {
          setUserIsScrollingUp(true);
        }
        setLastScrollY(window.scrollY);
      };
      window.addEventListener('scroll', listen);
      return () => window.removeEventListener('scroll', listen);
    }
    return undefined;
  }, [lastScrollY]);

  return (
    show && (
      <Button style={props} onClick={onClick}>
        <ArrowUpward />
      </Button>
    )
  );
};

const Button = simbaStyled(animated.button)(({ theme }) => ({
  display: 'none',
  position: 'fixed',
  background: colors.primary[500],
  color: colors.common.black,
  bottom: '20px',
  left: 'calc(50% - 20px)',
  width: '40px',
  height: '40px',
  borderRadius: '50% !important',
  border: 0,

  [`@media (max-width: ${breakpoints.l})`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      width: theme.spacing('l'),
      height: theme.spacing('l'),
      fill: colors.common.black,
    },
  },
}));
